export const AI_CONFIG = {
  apiKey: process.env.REACT_APP_OPENAI_API_KEY,
  MODEL: "gpt-3.5-turbo",
  TEMPERATURE: 0.7,
  MAX_TOKENS: 150
}; 